interface Props {
  heading: string;
}

export const SimpleSectionFormHeading = ({ heading }: Props) => {
  return (
    <div className="my-7 flex h-10 w-full items-center justify-start gap-4">
      <h2 className="heading-2 sm:heading-1">{heading}</h2>
    </div>
  );
};
